export default "__VITE_ASSET__OzPiD7Dx__"